import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import FilterButton from './FilterButton';
import FilterControls from './FilterControls';
import type { FilterState } from '@/types/filterTypes';

interface FilterPopoverProps {
  filters: FilterState;
  uniqueProfiles: string[];
  positions: { id: string; name: string }[];
  onFilterChange: (key: keyof FilterState, value: string | string[] | { min: number; max: number } | 'include' | 'exclude') => void;
  onResetFilters: () => void;
  hasActiveFilters: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const FilterPopover: React.FC<FilterPopoverProps> = ({
  filters,
  uniqueProfiles,
  positions,
  onFilterChange,
  onResetFilters,
  hasActiveFilters,
  open,
  onOpenChange
}) => {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <div>
          <FilterButton 
            hasActiveFilters={hasActiveFilters}
            onClick={() => onOpenChange(!open)}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent 
        className="w-96 p-0 bg-white border shadow-xl" 
        align="end"
        sideOffset={8}
      >
        <FilterControls
          filters={filters}
          uniqueProfiles={uniqueProfiles}
          positions={positions}
          onFilterChange={onFilterChange}
          onResetFilters={onResetFilters}
          hasActiveFilters={hasActiveFilters}
        />
      </PopoverContent>
    </Popover>
  );
};

export default FilterPopover;
